import { helpers } 		from './theme/helpers.js';
import { hamburger } 	from './theme/components/hamburger.js';
import { modal } 		from './theme/components/modal.js';

window.theme = {
	globals: {
		isTouch: typeof window !== 'undefined' && 'ontouchstart' in window,
		isTabActive: true,
		lastScroll: 0,
		arrow: '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512.002 512.002" style="enable-background:new 0 0 512.002 512.002;" xml:space="preserve"> <path fill="#4788c9" d="M388.425,241.951L151.609,5.79c-7.759-7.733-20.321-7.72-28.067,0.04c-7.74,7.759-7.72,20.328,0.04,28.067l222.72,222.105 L123.574,478.106c-7.759,7.74-7.779,20.301-0.04,28.061c3.883,3.89,8.97,5.835,14.057,5.835c5.074,0,10.141-1.932,14.017-5.795 l236.817-236.155c3.737-3.718,5.834-8.778,5.834-14.05S392.156,245.676,388.425,241.951z"></path></svg>',
	},
	init: function () {
		var self = this;

		// Global
		self.smoothScroll.init();
		self.onloadClass();
		self.touch();

		self.tilesSlider();
		self.referencesSlider();
		self.copyArticleUrl();
		self.fixedHeader();

		modal.init();
		hamburger.init();
	},
	onloadClass: function () {
		document.querySelector('body').classList.add('loaded');
	},
	tilesSlider: function () {
		var self = this;

		if( jQuery(".js-tilesSlider").length ) {
			var slider = tns({
				container: '.js-tilesSlider',
				items: 3,
				center: false,
				loop: false,
				swipeAngle: false,
				speed: 400,
				gutter: 40,
				mouseDrag: true,
				controlsText: [ self.globals.arrow, self.globals.arrow ],
				responsive: {
					1024: {
						items: 3,
						gutter: 40,
					},
					728: {
						items: 2,
						gutter: 24,
					},
					0: {
						items: 1
					},
				  }
			});

			/* var firstSlideSelector = function (info, eventName) {
				jQuery(".tiles__card--active").removeClass("tiles__card--active");
				jQuery(".tns-slide-active").first().find(".tiles__card").addClass("tiles__card--active");
			} 

			slider.events.on('indexChanged', firstSlideSelector);
			firstSlideSelector(); */
		}
	},
	referencesSlider: function () {
		if( jQuery(".js-referencesSlider").length ) {
			var slider = tns({
				container: '.js-referencesSlider',
				items: 1,
				center: false,
				loop: true,
				axis: 'vertical',
				autoHeight: true,
				swipeAngle: false,
				speed: 400,
				controls: false,
				mouseDrag: true,
			});

			/* var firstSlideSelector = function (info, eventName) {
				jQuery(".tiles__card--active").removeClass("tiles__card--active");
				jQuery(".tns-slide-active").first().find(".tiles__card").addClass("tiles__card--active");
			}

			slider.events.on('indexChanged', firstSlideSelector);
			firstSlideSelector(); */
		}
	},
	copyArticleUrl: function() {
		var self = this;

		jQuery('[data-copy-link]').on('click', function (event) {
			event.preventDefault();
			self.copyToClipboard( '[data-copy-link-url]' );

			jQuery(this).find("span").fadeIn().delay(1000).fadeOut();
        });
	},
	copyToClipboard: function(selector) {
		var copyText = document.querySelector( selector );

		copyText.select();
		copyText.setSelectionRange(0, 99999); /* For mobile devices */

		/* Copy the text inside the text field */
		document.execCommand("copy");
	},
	touch: function () {
		var self = this;

		var touchClass = self.globals.isTouch === true ? 'touch-device' : 'pointer-device';
		document.querySelector('body').classList.add( touchClass );
	},
	/* loadFancy: function() {
		// jQuery( 'p a[rel="noopener"]' ).has("img").fancybox(); class="fancybox" data-fancybox="gallery"
		jQuery( '.gallery-row a' ).each(function(){
			jQuery(this).attr( 'data-fancybox', 'gallery' );
		});
	}, */
	smoothScroll: {
		selector: 'a[href*="#"]',
		init: function () {
			var self = this;
			var scroll = new SmoothScroll(self.selector, {
				ignore: '[data-scroll-ignore]',
				topOnEmptyHash: false,
				speed: 1000,
				offset: 0,
				updateURL: false,
				easing: 'easeInOutCubic',
			});
		},
	},
	windowPosition: function () {
		return {
			x: window.pageXOffset || document.documentElement.scrollLeft,
			y: window.pageYOffset || document.documentElement.scrollTop,
		};
	},
	windowSizes: function () {
		return {
			width: Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0),
			height: Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0),
		};
	},
	onresize() {
		var self = this;
	},
	onscroll(position, previusPosition) {
		var self = this;

		self.fixedHeader();
	},
	fixedHeader: function() {
		var self = this;

		var currentScroll = self.windowPosition()['y'];

		var fixedHeader = currentScroll > 0;
		var body = document.querySelector('body');

		if ( fixedHeader ) {
			body.classList.add('fixed-header');
		} else {
			body.classList.remove('fixed-header');
		}
	}
};

jQuery(document).ready(function ($) {
	theme.init();
});

window.addEventListener('scroll', function (e) {
	theme.onscroll();
});

window.addEventListener('resize', function (e) {
	theme.onresize();
});

window.onfocus = function () { 
	theme.globals.isTabActive = true; 
}; 

window.onblur = function () { 
	theme.globals.isTabActive = false; 
}; 

jQuery.fn.isOnScreen = function(){
    var win = jQuery(window);

    var viewport = {
        top : win.scrollTop(),
        left : win.scrollLeft()
    };
    viewport.right = viewport.left + win.width();
    viewport.bottom = viewport.top + win.height();

    var bounds = this.offset();
    bounds.right = bounds.left + this.outerWidth();
    bounds.bottom = bounds.top + this.outerHeight();

    return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
};